import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Equipment, EquipmentCreate, GetParams, GetResponse, PostResponse} from '@app/shared';
import {Observable} from 'rxjs';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {

  /** URLs principales relacionadas con Equipments **/
  equipmentUrl = environment.coreApiBaseUrl + '/api/equipment';
  equipmentServiceUrl = environment.coreApiBaseUrl + '/api/EquipmentService';
  equipmentTypeUrl = environment.coreApiBaseUrl + '/api/EquipmentType';

  constructor(private http: HttpClient) { }

  /** Metodos de obtener/crear/actualizar/eliminar Equipment **/
  getEquipment(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.equipmentUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createEquipment(newEquipment: FormData): Observable<PostResponse> {
    const headers = new HttpHeaders({ enctype: 'multipart/form-data' });
    return this.http.post<PostResponse>(this.equipmentUrl, newEquipment, {
      headers});
  }

  updateEquipment(payload: FormData): Observable<any> {
    const headers = new HttpHeaders({ enctype: 'multipart/form-data' });
    return this.http.put(this.equipmentUrl, payload, {headers,});
  }

  deleteEquipment(equipmentIds: number[]): Observable<any> {
    return this.http.delete(this.equipmentUrl, {body: {ids: equipmentIds}});
  }

  /** Metodos de obtener/crear/actualizar/eliminar EquipmentService **/
  getEquipmentService(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.equipmentServiceUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createEquipmentService(value: {equipmentId: number, serviceId: number}): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.equipmentServiceUrl, value);
  }

  deleteEquipmentService(data: {equipmentsIds: number[], serviceId: number}): Observable<any> {
    return this.http.delete(this.equipmentServiceUrl + '/by-service-and equipments', {body: data});
  }

  /** Metodos de obtener/crear/actualizar/eliminar EquipmentType **/
  getEquipmentType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.equipmentTypeUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createEquipmentType(newEquipmentType: any): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.equipmentTypeUrl, newEquipmentType);
  }

  updateEquipmentType(payload: any): Observable<any> {
    return this.http.put(this.equipmentTypeUrl, payload);
  }

  deleteEquipmentType(equipmentTypeIds: number[]): Observable<any> {
    return this.http.delete(this.equipmentTypeUrl, {body: {ids: equipmentTypeIds}});
  }

}
